import { Button, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import Select from "../UI/Select";
import { monthList } from "../../util/DateUtil";

const PresencaTableFilter = ({ mesSelect, setMesSelect }) => {
  const onChangeMonth = (event) => {
    setMesSelect(event.target.value);
  };

  return (
    <Grid
      style={{ padding: "20px" }}
      container
      component={Paper}
      spacing={2}
      direction="column"
    >
      <Grid>
        <Typography variant="h6">Filtro</Typography>
      </Grid>
      <Grid>
        <Grid container direction="row" spacing={3} alignItems="center">
          <Grid>
            <Select
              label="Por Mês"
              value={mesSelect}
              list={monthList}
              onChange={onChangeMonth}
            />
          </Grid>
          <Grid>
            <Button
              onClick={() => setMesSelect("")}
              size="small"
              variant="outlined"
            >
              Limpar Filtro
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PresencaTableFilter;
